/**
 * Copyright © 2026 Adnuntius AS.
 */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import template from './layout-example-edit-page.component.html';

import {setupLayoutExamplePreview, translateLayoutComponentMediaTypes} from './layout-example-commons';
import {WINDOW} from '../../angular-platform-providers';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-layout-example-edit-page',
  template
})
export class LayoutExampleEditPageComponent implements OnChanges, AfterViewInit {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;

  codemirrorReady = false;
  private previewInitialized = false;

  @ViewChild('iframeContainer') iframeContainer: ElementRef<HTMLDivElement>;

  constructor(
    @Inject(WINDOW) private window: any,
    private translate: TranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnChanges(): void {
    if (this.model) {
      deferMarkForCheck(this.cdr, () => {
        this.codemirrorReady = true;
      });
      this.initPreview();
    }
  }

  ngAfterViewInit(): void {
    this.initPreview();
  }

  mediaTypesLabel(mimeTypes: string | string[]): string {
    return translateLayoutComponentMediaTypes(mimeTypes, (key) => this.translate.instant(key));
  }

  private initPreview(): void {
    if (this.previewInitialized || !this.model || !this.iframeContainer) {
      return;
    }
    this.previewInitialized = true;
    setTimeout(() => {
      setupLayoutExamplePreview(
        this.model,
        this.iframeContainer.nativeElement,
        this.window
      );
    }, 20);
  }
}
